import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/Col";
import MenuItems from "../geriactive/utils/menuItems/MenuItems";
import PLM_WEEKS, {
  PLM_TILE_FONT_COLOR,
  PLM_FUN_COLOR,
  PLM_FUN_BORDER_COLOR,
} from "./plmWeeks";

function PlmHomePage() {
  return (
    <div style={{ padding: "8px" }}>
      <Container>
        <Row
          style={{
            marginTop: "15px",
            height: "100%",
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Col>
            {PLM_WEEKS.map((week) => (
              <Col key={week.key} style={{ marginTop: "5px" }}>
                <MenuItems
                  url={week.path}
                  fontSize="30px"
                  title={week.title}
                  backgroundC={week.color}
                  fontColor={week.fontColor}
                  borderC={"5px solid " + week.borderColor}
                />
              </Col>
            ))}
            <Col style={{ marginTop: "5px" }}>
              <MenuItems
                url="/games"
                fontSize="30px"
                title="Just for Fun"
                backgroundC={PLM_FUN_COLOR}
                fontColor={PLM_TILE_FONT_COLOR}
                borderC={"5px solid " + PLM_FUN_BORDER_COLOR}
              />
            </Col>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PlmHomePage;
